<template>
  <v-list class="pt-0 pb-0 mb-2 info-list">
    <v-subheader
      center
      class="px-0"
    >
      {{ driverInfo[0].title }}
    </v-subheader>
    <template v-for="(group, gIndex) in driverInfo">
      <v-list-tile
        v-for="(property, index) in group.items"
        :key="index.toString() + gIndex.toString()"
        class="compact pl-0"
      >
        <v-layout row>
          <v-flex
            v-if="property.type !== 'reference'"
            xs5
          >
            <span class="blue--text text--darken-4">{{ property.title }}:</span>
          </v-flex>
          <v-flex
            v-if="property.type === 'text'"
            xs7
          >
            {{ property.value }}
          </v-flex>
          <v-flex
            v-if="property.type === 'reference'"
            xs11
          >
            <RouteReference
              :value="property.model"
              :label="property.title"
              :resource="property.resource"
              :store-resource="storeResource"
              :carrier-id="carrierId"
              component-name="Driver"
              :disabled-edit-btn="!property.model"
              @input="property.save"
            />
          </v-flex>
        </v-layout>
      </v-list-tile>
    </template>
  </v-list>
</template>
<script>
import RouteReference from "./RouteReference.vue";
export default {
  components: { RouteReference },
  props: ["resource", "item", "storeResource", "carrierId"],

  computed: {
    driver: {
      get() {
        return this.$store.getters[`${this.resource}/getDriver`];
      },
      set(value) {
        this.$store.commit(`${this.resource}/setDriver`, value);
      },
    },
    driverInfo() {
      const phones = [];
      if (this.item && this.item.driver && this.item.driver.viber) {
        phones.push({
          title: "Моб.номер.Viber",
          value: `+${this.item.driver.viber}`,
          type: "text",
        });
      }

      if (this.item && this.item.driver && this.item.driver.phones) {
        this.item.driver.phones.forEach((phone, index) => {
          phones.push({
            title: `Моб.номер${index + 1}`,
            value: phone,
            type: "text",
          });
        });
      }
      return [
        {
          title: "Информация о водителe",
          items: [
            {
              title: "Водитель",
              type: "reference",
              resource: "drivers",
              model: this.driver,
              save: (element) => {
                this.$emit("change", element);
              },
            },
            ...phones,
          ],
        },
      ];
    },
  },

};
</script>
